<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Detalle del turno</h1>
    </div>
  </div>

  <!-- Sections -->
  <div class="row-cols-12 m-2 mt-0">
    <div class="row row-cols-12 mt-0">
      <div class="col-8">
        <div class="text-p p-3 pb-0 nameUser">
          #{{ ordenPrestador?.id }}
        </div>

        <div class="ms-3 pb-0 ps-1 pe-1 rounded order-status">
          <i class="bi bi-check-circle"></i> Turno {{ ordenPrestador?.estadoOrden }}
        </div>
      </div>

      <div class="col-4 col-profile pe-3 pe-ms-5">
        <img class="text-end rounded-circle business-profile" src="./assets/img/iso-libresalud.png ">
      </div>
    </div>

    <hr class="divisor mt-3 mb-1">

    <div class="row text-center mt-3 mb-2 ps-2 pb-2">
      <!-- Columna 1: Profesional -->
      <div class="col-6 col-md-6 d-flex flex-column align-items-center">
        <a [routerLink]="[url_perfil_prestador]">
          <img class="rounded-circle profesional-img-detail mb-2" width="50px" [src]="preview_img_avatar_prestador">
        </a>
        <div class="fw-bold">Profesional:</div>
        <div>{{ ordenPrestador?.nombrePrestador }}</div>
      </div>

      <!-- Columna 2: Paciente -->
      <div class="col-6 col-md-6 d-flex flex-column align-items-center">
        <a [routerLink]="[url_perfil_cliente]">
          <img class="rounded-circle profesional-img-detail mb-2" width="50px" [src]="preview_img_avatar_cliente">
        </a>
        <div class="fw-bold">Paciente:</div>
        <div>{{ ordenPrestador?.nombreCliente }}</div>
      </div>
    </div>

    <hr class="divisor mt-1 mb-1">

    <div class="text-p p-3 pt-3 locationUser d-flex align-items-center">
      <span class="pe-0 d-flex align-items-center">
        <i class="bi bi-shop icons-detail pe-2"></i>
        <span>
          {{
            ordenPrestador?.d_fecha_turno
            ? (ordenPrestador?.d_fecha_turno | date: 'dd/MM/yyyy HH:mm') + 'hs'
            : 'Horario a confirmar'
          }}
        </span>
      </span>
    </div>

    <div class="text-p p-3 pt-2 locationUser d-flex align-items-center">
      <span class="pe-0 d-flex align-items-center">
        <i class="bi bi-geo-alt pe-2"></i>
        <span>{{ textoZona }}</span>
      </span>
    </div>

    @if (ordenPrestador?.x_img_receta) {
      <div class="text-p p-3 pt-2 locationUser d-flex align-items-center">
        <span class="pe-0 d-flex align-items-center" style="cursor:pointer;" (click)="openFile()">
          <i class="bi bi-file-earmark-text pe-2"></i>
          <span>Receta</span>
        </span>
      </div>
    }

    <div class="text-p p-3 pt-2 locationUser d-flex align-items-center">
      <span class="pe-0 d-flex align-items-center">
        <i class="bi bi-clipboard pe-2"></i>
        <span>
          {{
            ordenPrestador?.nombreEspecialidad || ordenPrestador?.nombrePrestacion
            ? (ordenPrestador?.nombreEspecialidad || '') +
              (ordenPrestador?.nombreEspecialidad && ordenPrestador?.nombrePrestacion ? ' - ' : '') +
              (ordenPrestador?.nombrePrestacion || '')
            : ordenPrestador?.nombrePrestador
          }}
        </span>
      </span>
    </div>

    <hr class="divisor mt-0 mb-1">

    <div class="row-cols-12 mt-0">
      <div class="row p-3 pb-2">
        <div class="col-6 col-lg-8">
          <div class="col col-lg-10 fw-bold title-total text-start">
            Precio
          </div>
          <div class="text-start description-product">
            {{ textoPago }}
          </div>
        </div>
        <div class="col-6 col-lg-4 fw-bold fieldInfo text-end text-truncate" style="justify-content: flex-end !important;">
          {{
            ordenPrestador?.n_precio_turno
            ? (ordenPrestador?.n_precio_turno | currency:'ARS')
            : 'Precio a confirmar'
          }}
        </div>
      </div>
    </div>

    <hr class="divisor mt-3 mb-4">
    @if (puedeAgregarCalendario){
        <div class="text-center">Agregá el turno a tu calendario</div>

        <div class="d-flex justify-content-between align-items-center mb-4 mt-2 ms-4 me-4">
            <!-- Columna 1: Descargar evento -->
            <a (click)="descargarICS()" class="text-decoration-none d-flex align-items-center p-2">
                <i class="bi bi-download me-2"></i>
                <span class="btn-descargar-ics">Descargar</span>
            </a>

            <!-- Columna 2: Google Calendar -->
            <a (click)="agregarAGoogleCalendar()" class="text-decoration-none d-flex align-items-center p-2">
                <i class="bi bi-google me-2"></i>
                <span class="btn-descargar-ics">Google</span>
            </a>

            <!-- Columna 3: Outlook -->
            <a (click)="agregarAOutlook()" class="text-decoration-none d-flex align-items-center p-2">
                <i class="bi bi-microsoft me-2"></i>
                <span class="btn-descargar-ics">Outlook</span>
            </a>
        </div>
    }

    <div class="row d-flex justify-content-center mt-1">
      <div class="col d-flex justify-content-evenly">
        @if (ordenPrestador?.id_estado_orden == 4 && id_perfil_usuario != 3) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/review-prestador/' + id]">
            <i class="bi bi-chat"></i> &nbsp; Calificar turno
          </button>
        }

        @if (ordenPrestador?.id_estado_orden == 9 && id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/review-prestador/' + id]">
            <i class="bi bi-chat"></i> &nbsp; Ver tu opinion
          </button>
        }

        @if (id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/ayuda']">
            Ayuda
          </button>
        }

        @if ((ordenPrestador?.id_estado_orden == 3 || ordenPrestador?.id_estado_orden == 6) && id_perfil_usuario == 3) {
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2 approve-order"
            [disabled]="loadingLocal() || loadingGlobal()"
            (click)="completadoOrderPrestador()">
            <i class="bi bi-check2-circle"></i> &nbsp;
            {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : 'Turno finalizado' }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (error()) {
    <div class="alert alert-danger mt-2" role="alert">
      <small>{{ error() }}</small>
    </div>
  }
</div>